import { TradingPartner } from './TradingPartner'
import { User } from './User'

export interface InstallationList {
  id: string
  name: string
  party: TradingPartner
  counterparty: TradingPartner
  parent?: string
  user?: User
  created_at: string
  updated_at: string
  deleted_at: string | null
  installation_type?: string
  onboarding?: string
  is_active: boolean
}

export interface InstallationComponent {
  id: string
  model: string
  metadata?: {
    name: string
  }
}

export interface InstallationDetail {
  id: string
  name: string
  party: TradingPartner
  counterparty: TradingPartner
  parent?: string
  user?: User
  created_at: string
  updated_at: string
  deleted_at: string | null
  parameters: any
  installation_type?: string
  integration_module?: string
  onboarding?: string
  components?: Array<InstallationComponent>
  is_active: boolean
  module_version?: string | null
  is_outdated?: boolean | null
}

export interface InstallationErrorDiagnostic {
  severity: 'error' | 'warning'
  summary: string
  detail: string
  location?: string | null
  snippet?: string[]
}

export interface InstallationErrorPayload {
  message: string
  diagnostics?: InstallationErrorDiagnostic[]
  raw_output?: string
}

export interface InstallationPlanChange {
  type: string
  address: string
  actions: string[]
  before?: Record<string, unknown> | null
  after?: Record<string, unknown> | null
}

export interface InstallationPlanResponse {
  changes: InstallationPlanChange[]
}

export interface InstallationApplyRequest {
  variables?: Record<string, unknown>
  module_version?: string
}

export type InstallationRequestStatus =
  | 'pending'
  | 'applying'
  | 'succeeded'
  | 'failed'
  | 'pending_rollback'
  | 'rolling_back'
  | 'rolled_back'
  | 'failed_needs_cleanup'

export const TERMINAL_INSTALLATION_REQUEST_STATUSES: InstallationRequestStatus[] = [
  'succeeded',
  'failed',
  'rolled_back',
  'failed_needs_cleanup',
]

export interface InstallationRequestAccepted {
  request_id: string
  status: InstallationRequestStatus
  channel: string
}

export interface InstallationRequestDetail {
  id: string
  data: Record<string, unknown>
  status: InstallationRequestStatus
  attempts: number
  error: InstallationErrorPayload | null
  installation: string | null
  channel: string
}

export interface InstallationRequestUpdatedEvent {
  request_id: string
  status: InstallationRequestStatus
  attempts: number
  error: InstallationErrorPayload | null
  installation: string | null
}
